function formatPhoneNumber(value) {
  let nums = value.toString().replace(/\D/g, '');
  let nextVal = '';

  if (nums.length > 3 && nums.length < 7) {
    nextVal += `${nums.substr(0, 3)}-`;
    nums = nums.substr(3);
  }

  if (nums.length > 6) {
    nextVal += `${nums.substr(0, 3)}-`;
    nextVal += nums.substr(3, 3) + '-';
    nums = nums.substr(6);
  }

  nextVal += nums;
  nextVal = nextVal.substr(0, 16);
  return nextVal;
}
function formatEmail(value) {
  return value.trim();
}

function formatMonthDayYear(value) {
  const num = value.toString().replace(/\D/g, '');
  const match = num.match(/(\d{2})(\d{1,2})?(\d*)/);

  if (match && match[0].length > 8) {
    return value.substring(0, value.length - 1);
  }

  if (!match || !match[2]) {
    return num;
  } else if (!match[3]) {
    return `${match[1]}/${match[2]}`;
  }

  return `${match[1]}/${match[2]}/${match[3]}`;
}

function formatZip(value) {
  return value.toString().replace(/\D/g, '');
}

function formatCity(value) {
  return value.replace(/[^a-z -]/gi, '');
}

function formatAddress(value) {
  return value.replace(/[^a-z0-9 '.,\-#/]/gi, '');
}

export { formatMonthDayYear, formatPhoneNumber, formatZip, formatCity, formatAddress, formatEmail };
